<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte nov nivo:
    </h2>

    <LevelForm
      @save="save"
      @cancel="cancel"
      :parentLevels="parentLevels"
      ref="form"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LevelForm from '@/components/LevelForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    LevelForm
  },
  mixins: [
    asyncDataStatus
  ],
  computed: {
    parentLevels () {
      return this.$store.state.levels.parentOptions
    }
  },
  methods: {
    ...mapActions('levels', ['saveItem']),
    save ({ data, repeat = false }) {
      const redirect = repeat ? null : 'MyCompanyLevels'
      this.saveItem({ id: this.id, ...data })
        .then(item => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          if (redirect) {
            this.$router.push({ name: redirect })
          } else {
            this.$refs.form.clearForm()
          }
        })
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyLevels' })
    }
  },
  created () {
    this.asyncDataStatus_fetched()
  }
}
</script>
